<template>
  <div>
    <!--检索-->
    <!--表格数据-->
    <el-table v-if="tableData" :data="tableData" stripe style="width: 100%; margin-top: 20px;">
      <el-table-column label="活动名称">
        <template slot-scope="scope">
          {{scope.row.activity_name}}
        </template>
      </el-table-column>
       <el-table-column label="活动时间">
        <template slot-scope="scope">
         {{scope.row.start_time}} - {{scope.row.end_time}}
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" width="100" align="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="select(scope.row, scope.$index)">
            {{ scope.row.select ? '已选取' : '选取'}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div v-if="tableData" class="pagination-wrapper">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="requestData.count" layout="total, prev, pager, next" :total="totalNumber">
      </el-pagination>
    </div> -->
    <el-row type="flex" justify="center">
      <div class="bottom-btn-box">
        <el-button class="btn-long" type="primary" @click="closeDialog">关闭</el-button>
      </div>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
import Util from "@/js/util";

export default {
  props: {
    // 请求的URL
    url: {
      default: "",
      type: String
    },
    // 默认请求参数
    params: {
      default: function() {
        return { status: 1 };
      },
      type: Object
    },
    // 页面配置
    pageData: {
      default: {},
      type: Object
    },
    // 服务端返回的数组名称
    resultArrayName: {
      default: "item_list",
      type: String
    },
    // 分页数量
    count: {
      default: 20,
      type: Number
    },
    // 是否支持多选
    multi: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      limitUpload:1,
      fileTemp:null,

      searchText: "",
      // 表格数据 & 翻页
      tableData: null,
      totalNumber: null,
      currentPage: 1,
      requestData: {
        // 翻页参数
        offset: 0,
        count: 20
      },
    };
  },
  mounted () {
    this.request()
  },
  watch: {
    pageData: {
      handler(val) {
        const module_list = val.module_list
        this.tableData.forEach( (el ,i) => {
          el.select = module_list.some(el2 => (el2.active_item || {}).id === el.id);
        })
      },
      deep: true,
    },
  },
  methods: {
    handleChange(file, fileList){
      this.fileTemp = file.raw
    },

    handleRemove(file,fileList){
      this.fileTemp = null
    },
    handleExceed(){

    },
    excelSuccess(res){
      if(res.data && res.data.length){
        let idList = [];
        res.data.forEach((item)=>{
          if(item && item.ID){
            idList.push(item.ID);
          }
        })
        this.requestIdList(idList);
      }
    },
    requestIdList(idList){
      lib.api.post({
        api: 'ec/b/item/query/composite/item',
        data: {
          item_id_list:JSON.stringify(idList)
        },
        success: res => {
          if(res.data && res.data.data && res.data.data.length){
            res.data.data.forEach((item)=>{
              item.promotion_price = Util.filterPrice(item.promotion_price);
              if(item.channel_labels){
                item.channel_tags = this.getItemChannel(item.channel_labels.split(' '));
              }
            })
          }

          this.tableData = res.data.data;
          this.totalNumber = res.data.data.total_count;
          if(this.pageData.app_type == 'seller') {
            this.tableData.forEach((item, index) => {
              this.getSellerItem(item.id, index);
            })
          }
        },
        error: data => {
          if(data.code ==50004){
            lib.login.goLogin();
          }
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {}
      });
    },
    request() {
      lib.api.get({
        api: 'ec/b/operation/activity/list/tms',
        data: {
        },
        success: res => {
          res.data.forEach(item => {
            item.select = false;
            this.pageData.module_list.forEach(mod => {
              if (item.id === (mod.active_item || {}).id) {
                item.select = true;
              }
            })
          })
          this.tableData = res.data;
        },
        error: data => {
          if(data.code ==50004){
            lib.login.goLogin();
          }
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {}
      });
    },
    search() {
      this.request();
    },
    select(row, index) {
      this.tableData.forEach( (el ,i) => {
         el.select = false
      })
      row.select = true;
      this.$emit("select", row);
    },
    handleCurrentChange(val) {
      this.requestData.offset = this.requestData.count * (val - 1) || 0;
      this.request();
    },
    closeDialog() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="sass">
</style>